// libs
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Chip, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';

// icons

// assets
import i18n from 'FRONTEND/utils/i18n';


export const BreadcrumbWithCopyToClipboard = ({ label, startIcon, value }) => {
  const [copySuccess, setCopySuccess] = useState('');
  const timeoutRef = React.useRef(null);

  const handleCopyAccessCode = (valueToCopy) => {
    navigator.clipboard.writeText(valueToCopy)
      .then(() => {
        setCopySuccess(i18n._('Copied'));
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => setCopySuccess(''), 2000);
      })
      .catch(err => {
        console.error('Error copying text: ', err);
      });
  };

  return (
    <Stack direction='row' gap={1} justifyContent='end' alignItems='center'>
      {copySuccess && (
        <Chip
          label={copySuccess}
          color='success'
          sx={{
            fontSize: '12px',
            height: '14px',
          }}
        />)}
      {startIcon}
      <Stack direction='row' gap={1} alignItems='center' onClick={() => handleCopyAccessCode(value)} sx={{ cursor: 'pointer' }}>
        <Typography variant='button' sx={{ fontSize: '16px', whiteSpace: 'nowrap' }}>{label}</Typography>
        <Typography
          variant='button'
          sx={{
            fontSize: '15px',
            color: (theme) => theme.palette.grey[700],
            whiteSpace: 'nowrap',
          }}
        >
          {value}
        </Typography>
        <ContentCopyIcon fontSize='12px' />
      </Stack>
    </Stack>
  );
};
